module.exports = __webpack_public_path__ + "img/bell.b6da4279.svg";